<template>
  <div class>
    <el-card>
      <div style="display:flex;">
        <div style="display:flex;justify-content:space-around;width:70%;margin-top:5px">
          <span>用户账号：{{ form.loginName }}</span>
          <span>用户姓名：{{ form.userName }}</span>
          <span>企业钱包：{{ form.unitBalance }}</span>
          <!-- <span>赠送账户：{{form.unitBalance}}</span> -->
          <span>个人钱包：{{ form.personalBalance }}</span>
          <!-- <span>充值账户：{{form.personalBalance}}</span> -->
        </div>
        <div style="float:right">
          <el-button type="primary" plain permission="user.notenterprise.wallet.Correction" @click="recharge">余额修正</el-button>
          <el-button type="primary" plain @click="back">返回</el-button>
          <el-dialog
            v-dialogDrag
            title="余额修正"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            width="50%"
            center
          >
            <el-form ref="rechargeForm" :model="rechargeForm" :rules="rechargeFormRules" label-width="100px" style="width:80%;margin:auto">
              <el-form-item label="钱包类型" prop="moneyType">
                <el-radio-group v-model="rechargeForm.moneyType">
                  <el-radio :label="0">企业钱包</el-radio>
                  <el-radio :label="1">个人钱包</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="修正金额" prop="money">
                <div style="display:flex">
                  <el-input v-model="rechargeForm.money" @input='iptFn'/>
                  <span style="margin-left: 10px;">元</span>
                </div>
              </el-form-item>
              <el-form-item label="备注" prop="remark">
                <el-input v-model="rechargeForm.remark" type="textarea" />
              </el-form-item>
              <el-form-item style="margin-left:50px">
                <el-button @click="onSubmit(false)">取消</el-button>
                <el-button type="primary" @click="onSubmit(true)">保存</el-button>
              </el-form-item>
            </el-form>
          </el-dialog>
        </div>
      </div>
    </el-card>
    <el-card>
      <div style="clear: both;">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="钱包流水" name="flow" />
          <el-tab-pane label="月账单" name="bill" style="float:right">
          <!-- <div>
            <el-form ref="checkForm" :model="checkForm" style="float:right;width: 400px;">
              <el-form-item label="按月查询">
                <el-date-picker
                  v-model="checkForm.value"
                  type="datetime"
                  placeholder="选择日期时间">
                </el-date-picker>
                <el-button type="primary" plain @click="query(true)">查询</el-button>
              </el-form-item>
          </el-form>
          </div> -->
          </el-tab-pane>
        </el-tabs>

        <STable
          v-show="isFlow"
          ref="flowTableref"
          :selection="false"
          :url="this.flow.url"
          :columns="this.flow.columns"
        />

        <STable
          v-show="isBill"
          ref="billTableref"
          :selection="false"
          :url="this.bill.url"
          :columns="this.bill.columns"
          :query="this.bill.query"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { HOST, EV_HOST } from '@/utils/host'
export default {
  name: 'Feiqiyeyonghuqianbao',
  components: {},
  data() {
    return {
      dialogVisible: false,
      form: {},
      rechargeForm: {
        moneyType: 0,
        money: '',
        remark: ''
      },
      rechargeFormRules: {
        moneyType: [
          { required: true }
        ],
        money: [
          { required: true, message: '请输入修正金额', trigger: 'blur' },
          {
            validator(rule, value, callback) {
              // var g = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
              var g = /^-?\d*\.?\d+$/
			  if (g.test(value)) {
                callback()
              } else {
                callback(new Error('请输入正确数值'))
              }
            }
          }
        ],
        remark: [
          { required: true, message: '请输入备注', trigger: 'blur' }
        ]
      },
      checkForm: {},
      activeName: 'flow',
      flow: {
        url: '',
        columns: [
          {
            label: '流水号',
            prop: 'billId'
          },
          // {
          //   label:'关联编号',
          //   prop:"joinId"
          // },
          // {
          //   label:'微信商户订单id',
          //   prop:"wxBusId"
          // },
          {
            label: '流水类型',
            prop: 'type'
          },
          {
            label: '流水金额',
            prop: 'money',
            template: (index, reocrd) => {
              return this.getFixed2(reocrd.money)
            }
          },
          {
            label: '支付钱包',
            prop: 'payTypeDesc'
          },
          {
            label: '备注',
            prop: 'remark'
          },
          {
            label: '流水时间',
            prop: 'createDate'
          }
        ]
      },
      bill: {
        url: '',
        columns: [
          {
            label: '订单号',
            prop: 'orderId'
          },
          {
            label: '消费类型',
            prop: 'type'
          },
          {
            label: '消费金额',
            prop: 'money',
            template: (index, reocrd) => {
              return this.getFixed2(reocrd.money)
            }
          },
          {
            label: '消费时间',
            prop: 'spendingTime'
          }
        ],
        query: [
          {
            label: '按月查询',
            prop: 'month',
            type: 'date',
            option: {
              type: 'month',
              format: 'yyyy-MM'
            }
          }
        ]
      },
      isFlow: false,
      isBill: false,
      accountId: ''
    }
  },
  computed: {},
  mounted() {
    this.getWallet()
    this.isFlow = true
        this.$refs.flowTableref.queryTable()
    this.$refs.billTableref.queryTable()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.accountId = this.$route.query.data
    this.flow.url = '/user/bill/findBill?accountId=' + this.accountId
    this.bill.url = '/user/order/findOrder?accountId=' + this.accountId
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
         iptFn(e){
      if(e.length>=9){
   this.rechargeForm.money=e.substr(0,9)
      }
    },
    back() {
      this.$router.go(-1)
    },

    number() {
      this.famount = this.famount.replace(/[^\.\d]/g, '')
      this.famount = this.famount.replace('.', '')
    },
    recharge() {
      this.title = true
      this.dialogVisible = true
    },
    async onSubmit(flag) {
      if (!flag) {
        this.dialogVisible = false
        this.$refs.rechargeForm.resetFields()
        // this.rechargeForm.money = '';
        // this.rechargeForm.remark = '';
        return
      } else {
        try {
          // 必填校验
          await Promise.all([
            this.$refs.rechargeForm.validate()
          ])
        } catch (error) {
          return
        }
      }
	  const data = {
	    id: this.accountId,
	    moneyType: this.rechargeForm.moneyType,
	    money: this.rechargeForm.money,
	    remark: this.rechargeForm.remark
	  }

      this.$store.dispatch('form/handle', {
        url: '/user/bill/chargeOrRefund',
        data: data,
        method: 'post',
        callback: resp => {
          this.dialogVisible = false
          this.rechargeForm.money = ''
          this.rechargeForm.remark = ''
          this.getWallet()
          this.$refs.flowTableref.queryTable()
          this.$refs.billTableref.queryTable()
        }
      })
    },
    handleClick(tab, event) {
      if (tab.name === 'flow') {
        this.isFlow = true
        this.isBill = false
        this.$refs.flowTableref.queryTable()
      } else if (tab.name === 'bill') {
        this.isFlow = false
        this.isBill = true
        this.$refs.billTableref.queryTable()
      }
    },

    getWallet() {
      const data = {
        accountId: this.accountId
      }
      this.$store.dispatch('form/handle', {
        url: '/user/account/getWallet',
        method: 'get',
        data: data,
        callback: resp => {
          console.log(resp)
          resp.unitBalance = this.getFixed2(resp.unitBalance)
		  resp.personalBalance = this.getFixed2(Number(resp.personalBalance)+Number(resp.activityBalance))
          this.form = resp
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/userManagement/isuserWallet.vue